export default "__VITE_ASSET__CUNog5yA__"